<template>
    <b-modal
        v-model="modalShow"
        size="md"
        title="Googleカレンダーと連携"
        hide-footer>
        <template>
            <div class="mb-3">
                Googleカレンダーと連携することで、{{ $locale.consultation_host }}予約の予定時間帯を自動的にGoogleカレンダーへ反映することができます。
            </div>
            <div class="mb-4">
                また、Googleカレンダーで個人的な予定を追加した際は、その時間帯を休診の例外スケジュールとしてYOKUMIRUに反映することができます。
            </div>
            <div class="mb-2 d-flex justify-content-center">
                <img
                    src="/images/common/btn_oauth_google.svg"
                    class="oauthGoogle"
                    @click="oauthGoogle">
            </div>
        </template>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
                calendar: {
                    is_public: 0,
                    url: "",
                },
                isCopiedCalendarUrl: false,
            };
        },

        created: function() {
            bus.$on('open-modal-doctor-google-calendar-linkage', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-google-calendar-linkage')
        },

        methods: {
            open: function () {
                this.modalShow = true
            },

            close: function () {
                this.modalShow = false
            },

            /**
             * @see https://developers.google.com/identity/branding-guidelines?hl=ja#top_of_page
             */
            oauthGoogle: function () {
                window.location.href = '/doctor/social/oauth/redirect/google'
            },
        },
    }
</script>

<style scoped lang="scss">
.oauthGoogle {
    cursor: pointer;
}
</style>
